import React from 'react';
import { useTranslation } from 'react-i18next';
import HeroGroup from '../../../../images/webps/hero-group.webp';
import styles from './Hero.module.css';

function Hero() {
  const { t } = useTranslation('home');

  return (
    <section className={styles.root}>
      <div className={styles.container}>
        <div className={styles.text}>
          <h1 className={styles.title}>
            {t('HERO_TITLE_PREFIX')}{' '}
            <span className={styles.highlight}>
              {t('HERO_TITLE_HIGHLIGHT')}
            </span>
            <br />
            {t('HERO_TITLE_SUFFIX')}
          </h1>
          <p className={styles.subtitle}>{t('HERO_SUBTITLE')}</p>
        </div>
        <div className={styles.imageWrap}>
          <img
            src={HeroGroup}
            alt={t('HERO_IMAGE_ALT')}
            className={styles.image}
          />
        </div>
      </div>
    </section>
  );
}

export default Hero;
